import { render, staticRenderFns } from "./AvatarSelect.vue?vue&type=template&id=df815c4c&scoped=true&"
import script from "./AvatarSelect.vue?vue&type=script&lang=js&"
export * from "./AvatarSelect.vue?vue&type=script&lang=js&"
import style0 from "./AvatarSelect.vue?vue&type=style&index=0&id=df815c4c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df815c4c",
  null
  
)

export default component.exports